<script>
import TwDropdown from '@/components/generic/dropdown/tw-dropdown.vue'
import TwDropdownItem from '@/components/generic/dropdown/tw-dropdown-item.vue'
import FundraiserRebuildCacheButton from '@/components/fundraisers/actions/fundraiser-rebuild-cache-button.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'

export default {
  name: 'FundraiserManageDropdown',
  components: { FontAwesomeIcon, FundraiserRebuildCacheButton, TwDropdownItem, TwDropdown},
  mixins:[ loggedInUserMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Loading: false
    }
  }
}
</script>

<template>
  <tw-dropdown class="w-full justify-end font-sans" no-dropdown-icon>
    <template #button>
      <font-awesome-icon icon="cog" :spin="Loading" />
    </template>
    <tw-dropdown-item :to="{ name: 'FundraiserDetailsPage', params: { fundraiserId: fundraiser.id } }">
      Edit
    </tw-dropdown-item>
    <tw-dropdown-item :to="{ name: 'FundraiserSupportPagesPage', params: { fundraiserId: fundraiser.id } }">
      Supporters
    </tw-dropdown-item>
    <tw-dropdown-item :to="{ name: 'FundraiserDonationsPage', params: { fundraiserId: fundraiser.id } }">
      Donations
    </tw-dropdown-item>
    <fundraiser-rebuild-cache-button component="tw-dropdown-item" :fundraiser="fundraiser" />
  </tw-dropdown>
</template>

<style scoped>

</style>
